import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { DepotLocation } from '@shared/models/depot-location.enum';
import { CarHireDepotSearchResultResponse } from '@shared/shared/interfaces/travel-car-hire.interfaces';
import { LanguageService } from '@shared/shared/services/language-service';
import { forkJoin, of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import * as fromActions from '../actions/car-hire-details.actions';

@Injectable()
export class CarHireDetailsEffects {
  constructor(private actions$: Actions, private http: HttpClient, private languageService: LanguageService) {}

  public getCarHireDetails$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fromActions.GET_CAR_HIRE_DETAILS),
      switchMap((action: fromActions.GetCarHireDetails) => {
        const language = this.languageService.currentLanguage;
        const requests = [
          this.http.get(`/static-content/shared/${language}/depots/${action.payload.dropOffId}.json`).pipe(
            map((data: any) => {
              return {
                depot: DepotLocation.DROP_OFF,
                data,
              };
            }),
            catchError((err) => {
              return of(new fromActions.GetCarHireDetailsFailure(err));
            })
          ),
        ];

        if (action.payload.dropOffId !== action.payload.pickUpId) {
          requests.push(
            this.http.get(`/static-content/shared/${language}/depots/${action.payload.pickUpId}.json`).pipe(
              map((data: any) => {
                return {
                  depot: DepotLocation.PICK_UP,
                  data,
                };
              }),
              catchError((err) => {
                return of(new fromActions.GetCarHireDetailsFailure(err));
              })
            )
          );
        }

        return forkJoin(requests);
      }),
      switchMap((data: { depot: DepotLocation; data: CarHireDepotSearchResultResponse }[]) => [
        new fromActions.GetCarHireDetailsSuccess(data[0]),
        new fromActions.GetCarHireDetailsSuccess(
          data[1].depot === DepotLocation.PICK_UP
            ? data[1]
            : {
                ...data[0],
                depot: DepotLocation.PICK_UP,
              }
        ),
      ])
    )
  );
}
